import { graphql } from 'gatsby'
import { dotPath } from 'ramdasauce'

import { VideoView } from 'components/views'

const VideoPage = ({ data: queryResult }) => {
  const data = dotPath('sanityVideoTile', queryResult)
  const queueData = dotPath('sanityVideoQueue', queryResult)

  return <VideoView data={data} queueData={queueData} />
}

export default VideoPage

export const videoQuery = graphql`
  query ($pageId: String) {
    sanityVideoTile(id: { eq: $pageId }) {
      title
      category
      interviewee
      urlSlug {
        current
      }
      vimeoId
      thumbnail {
        asset {
          gatsbyImageData(
            layout: FULL_WIDTH
            formats: [WEBP, AUTO]
            aspectRatio: 1.7778
          )
        }
      }
      socialLinks {
        id
        title
        backgroundColor
        paragraph
        ctaButtons {
          ...SanityButton
        }
      }
    }
    sanityVideoQueue {
      queueOrder {
        id
        title
        category
        interviewee
        urlSlug {
          current
        }
        vimeoId
        thumbnail {
          asset {
            gatsbyImageData(
              layout: FULL_WIDTH
              formats: [WEBP, AUTO]
              aspectRatio: 1.7778
            )
          }
        }
      }
    }
  }
`
